// extracted by mini-css-extract-plugin
export default {"sideDrawer__main":"SearchForAutomation_sideDrawer__main__KVNqD","sideDrawer__content":"SearchForAutomation_sideDrawer__content__AA0e6"};